import type { SelectableService } from "./CustomSubscriptionServicesEditor";

/**
 * The bookable services plus any on the plan that are no longer listed, so a
 * service deleted since it was added still shows as selected in its row.
 */
export function getSelectableServices(
  activeServices: SelectableService[],
  planServices: { serviceId: number; serviceName: string }[],
): SelectableService[] {
  const activeServiceIds = new Set(
    activeServices.map((service) => service.serviceId),
  );
  const planOnlyServices = planServices
    .filter((service) => !activeServiceIds.has(service.serviceId))
    .map((service) => ({
      serviceId: service.serviceId,
      name: service.serviceName,
    }));
  return [...activeServices, ...planOnlyServices];
}
